<app-loader></app-loader>
<it-notifications></it-notifications>
<div class="container-fluid">
  <app-header *ngIf="showHeader"></app-header>
  <router-outlet />
</div>
